module.exports = {"id":"s5-q4","text":"How often do you check your email?","multiselect":false,"next":"s5-q5","options":[{"id":"s5-q4-a1","text":"Less than once a month","capability":-3,"access":-2},{"id":"s5-q4-a2","text":"Two or three times a month","capability":-2,"access":-2},{"id":"s5-q4-a3","text":"Every week","capability":0,"access":0},{"id":"s5-q4-a4","text":"Most days","capability":1,"access":1},{"id":"s5-q4-a5","text":"Every day","capability":1,"access":2},{"id":"s5-q4-a6","text":"Multiple times a day","capability":2,"access":2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s5-q4.json
// module id = 911
// module chunks = 41